import React, {Component} from "react";
import config from 'react-global-configuration';
import axios from "axios";
import ReactMultiSelectCheckboxes from 'react-multiselect-checkboxes';
import { reactSelectStyles } from '../helpers/utils.js';

class OpenTicketPriority extends Component {
    state = {
        OpenTicketPriorityLists:[],
        OpenTicketPriorityValue: '',
        isOpenTicketPriorityLoading: true
    };
    componentDidMount(){
        this.getOpenTicketPriority();
    }
    restOpenTicketPriorityFilter() {
        this.setState({
            OpenTicketPriorityValue: [],
        })
    }
    getOpenTicketPriority(){
        axios.get(config.get('API_URL')+'/filters/get-ticket-priority/',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
            params: {
                user_type: this.props.userType,
            }
        }).then(response => {
            if(Array.isArray(response.data) && response.data.length) {
                response.data.map((priority, index) => {
                    this.state.OpenTicketPriorityLists.push({value: priority.priority, label: priority.priority})
                });
            }
            this.setState({
                isOpenTicketPriorityLoading: false
            })
        });

    }


    changeOpenTicketPriority(optionSelected){
        let value='';
        let tenderArray = [];
        if(optionSelected.length < 1){
            value = null;
            tenderArray = '';
        }
        else{
            optionSelected.map((ids, i) => {
                tenderArray.push(ids.value)
                var index = this.state.OpenTicketPriorityLists.findIndex(obj => obj.value==ids.value);
                this.state.OpenTicketPriorityLists.move(index,0).join(',');
            });
        }
        this.props.onSelectOpenTicketPriority(optionSelected, tenderArray);
        this.setState({
            OpenTicketPriorityValue:optionSelected,
        });

    }
    render() {

        return (
            <ReactMultiSelectCheckboxes name="event_name"
                isMulti
                value={this.state.OpenTicketPriorityValue}
                styles={reactSelectStyles} className="report-listbox"
                isClearable={false}
                onChange={this.changeOpenTicketPriority.bind(this)}
                options={this.state.OpenTicketPriorityLists}
                placeholderButtonLabel="Select [Priority]"
                isLoading={this.state.isOpenTicketPriorityLoading}
            />
        );

    }
}
export default OpenTicketPriority;